import { NgModule } from '@angular/core';
import { ByteLengthDirective } from './byte-length.directive';

@NgModule({
  imports: [
    
  ],
  declarations: [ByteLengthDirective],
  exports: [ByteLengthDirective]
})
export class ByteLengthModule {}
